import React from 'react';
export const NotificationContext = /*#__PURE__*/React.createContext({});
export const useNotificationContext = () => {
  return React.useContext(NotificationContext);
};
//# sourceMappingURL=NotificationContext.js.map